import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';
import FeedOutlinedIcon from '@mui/icons-material/FeedOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import SwitchAccountOutlinedIcon from '@mui/icons-material/SwitchAccountOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BusinessIcon from '@mui/icons-material/Business';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import { ElementType } from 'react';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import NoteIcon from '@mui/icons-material/Note';
import ScreenRotationAltIcon from '@mui/icons-material/ScreenRotationAlt';
import { getCookie } from '@utils/getCookie';
import PersonIcon from '@mui/icons-material/Person';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import BlockIcon from '@mui/icons-material/Block';
import PaymentIcon from '@mui/icons-material/Payment';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import GroupsIcon from '@mui/icons-material/Groups';

const masterKey = getCookie('master_key');

import { primaryOrange } from '@styles/colors';

export type SidebarMenuItem = {
  text: string;
  link: string;
  Icon: ElementType;
  addGapBeforeItem?: boolean;
  badgeCount?: number;
  buttonColor?: string;
};

export const employerSidebarMenuItems: SidebarMenuItem[] = [
  {
    text: 'Applicants',
    link: '/dashboard/',
    Icon: SwitchAccountOutlinedIcon,
  },
  {
    text: 'Inbox',
    link: '/inbox/',
    Icon: EmailOutlinedIcon,
  },
  {
    text: 'Interviews',
    link: '/employer/calendar/',
    Icon: CalendarMonthOutlinedIcon,
  },
  {
    text: 'Job Management',
    link: '/employer/positions/',
    Icon: WorkOutlineOutlinedIcon,
  },
  {
    text: 'Application Questions',
    link: '/employer/application-questions/',
    Icon: HelpOutlineIcon,
  },
  {
    text: 'My Team',
    link: '/employer/my-team/',
    Icon: GroupsIcon,
  },
  {
    text: 'Onboarding',
    link: '/employer/account/onboarding/',
    Icon: SendOutlinedIcon,
  },

  {
    text: 'Integrations',
    link: '/employer/integrations/',
    Icon: ExtensionOutlinedIcon,
  },
  {
    text: 'WOTC',
    link: '/employer/account#WOTC',
    Icon: CalculateOutlinedIcon,
  },
  {
    text: 'Manage Users',
    link: '/employer/account#Manage-Users',
    Icon: GroupOutlinedIcon,
  },
  ...(masterKey ? [{
    text: 'Back to Dashboard',
    link: '/back/',
    Icon: DashboardIcon,
  }] : []),
  {
    text: 'Account Settings',
    link: '/employer/account',
    Icon: SettingsOutlinedIcon,
    addGapBeforeItem: true,
  },
  {
    text: 'Logout',
    link: '/logout/',
    Icon: LogoutOutlinedIcon,
  },
];

export const applicantSidebarMenuItems: SidebarMenuItem[] = [
  {
    text: 'Applications',
    link: '/applicants/',
    Icon: HomeOutlinedIcon,
  },
  {
    text: 'Inbox',
    link: '/applicants/inbox/',
    Icon: EmailOutlinedIcon,
  },
  {
    text: 'Interviews',
    link: '/applicants/calendar',
    Icon: CalendarMonthOutlinedIcon,
  },
  {
    text: 'New Hire Paperwork',
    link: '/applicants/onboarding/',
    Icon: FeedOutlinedIcon,
  },
  {
    text: 'My Resume',
    link: '/applicants/resume/',
    Icon: ArticleOutlinedIcon,
  },
  {
    text: 'Job Interests',
    link: '/applicants/job-interests',
    Icon: WorkOutlineOutlinedIcon,
  },
  {
    text: 'Search All Jobs',
    link: `${import.meta.env.VITE_MARKETING_SITE_URL}jobs`,
    Icon: SearchOutlinedIcon,
    buttonColor: primaryOrange,
  },
  ...(masterKey ? [{
    text: 'Back to Dashboard',
    link: '/back/',
    Icon: DashboardIcon,
  }] : []),
  {
    text: 'Account Settings',
    link: '/applicants/account',
    Icon: SettingsOutlinedIcon,
    addGapBeforeItem: true,
  },
  {
    text: 'Logout',
    link: '/logout/',
    Icon: LogoutOutlinedIcon,
  },
];

export const enterPriseSidebarMenuItems: SidebarMenuItem[] = [
  {
    text: 'Applicants',
    link: '/enterprise/',
    Icon: DashboardIcon,
  },
  {
    text: 'Inbox',
    link: '/enterprise/inbox/',
    Icon: EmailOutlinedIcon,
  },
  {
    text: 'Interviews',
    link: '/enterprise/calendar/',
    Icon: CalendarMonthOutlinedIcon,
  },
  {
    text: 'Digital Onboarding',
    link: '/enterprise/onboarding',
    Icon: SendOutlinedIcon,
  },
  {
    text: 'WOTC',
    link: '/enterprise/account#WOTC',
    Icon: CalculateOutlinedIcon,
  },
  {
    text: 'Manage Companies',
    link: '/enterprise/companies/',
    Icon: BusinessIcon,
  },
  {
    text: 'Company Template',
    link: '/enterprise/templates/',
    Icon: ScreenRotationAltIcon,
  },
  {
    text: 'Billing',
    link: '/enterprise/billing/',
    Icon: PaymentIcon,
  },
  {
    text: 'Manage Users',
    link: '/enterprise/account#Manage-Users',
    Icon: GroupOutlinedIcon,
  },
  ...(masterKey ? [{
    text: 'Back to Dashboard',
    link: '/back/',
    Icon: DashboardIcon,
  }] : []),
  {
    text: 'Account Settings',
    link: '/enterprise/account',
    Icon: SettingsOutlinedIcon,
    addGapBeforeItem: true,
  },
  {
    text: 'Logout',
    link: '/logout/',
    Icon: LogoutOutlinedIcon,
  },
];

export const rokerboxSidebarMenuItems: SidebarMenuItem[] = [
  {
    text: 'Home',
    link: '/rockerbox/',
    Icon: DashboardIcon,
  },
  {
    text: 'Inbox',
    link: '/rockerbox/messages/',
    Icon: EmailOutlinedIcon,

  },
  ...(masterKey ? [{
    text: 'Back to Dashboard',
    link: '/back/',
    Icon: DashboardIcon,
  }] : []),
  {
    text: 'Logout',
    link: '/logout/',
    Icon: LogoutOutlinedIcon,
    addGapBeforeItem: true,
  },
];

export const adminSidebarMenuItems: SidebarMenuItem[] = [
  {
    text: 'Employers',
    link: '/admin/',
    Icon: AssignmentIndIcon,

  },
  {
    text: 'Enterprises',
    link: '/admin/enterprises/',
    Icon: SupervisorAccountIcon,
  },
  {
    text: 'Applicants',
    link: '/admin/applicants/',
    Icon: PersonIcon,
  },
  {
    text: 'Templates',
    link: '/admin/templates/',
    Icon: TextSnippetOutlinedIcon,
  },
  {
    text: 'Industries / Positions',
    link: '/admin/industries-positions/',
    Icon: WarehouseIcon,
  },
  {
    text: 'WOTC',
    link: '/admin/wotc-users/',
    Icon: NoteIcon,
  },
  {
    text: 'Manage Users',
    link: '/admin/manage-users/',
    Icon: PersonAddIcon,
  },
  {
    text: 'CRM Tagging',
    link: '/admin/crm-tagging/',
    Icon: LocalOfferIcon,
  },
  // {
  //   text: 'Spam Accounts',
  //   link: '/admin/spam-companies/',
  //   Icon: InfoIcon,
  // },
  {
    text: 'Blocked Accounts',
    link: '/admin/block-companies/',
    Icon: BlockIcon,
  },
  {
    text: 'Logout',
    link: '/logout/',
    Icon: LogoutOutlinedIcon,
    addGapBeforeItem: true,
  },
];
